@use '../../../../../styles/Constants.scss' as Constants;

.diffsContainer {
	display: grid;
	grid-template-columns: max-content auto;
	column-gap: Constants.$val-spacing-m;
	margin-top: Constants.$val-spacing-s;
}

.itemLabel {
	font-weight: bold;
}